module.exports = __webpack_public_path__ + "static/img/2.897dd89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/eng/2.png
// module id = nLYc
// module chunks = 0